import React, { useState } from 'react';
export function AccordionWrapper({ children, allowMultipleOpen = false }) {
    // These states below are controlling all the nav containers open/cose/hover status, if they are wrapped in the accordion wrapper
    const [openedItems, setOpenedItems] = useState([]);
    const [hoveredItem, setHoveredItem] = useState(-1);
    return (React.createElement(React.Fragment, null, React.Children.map(children, (child, index) => React.cloneElement(child, {
        openedItems,
        ...(allowMultipleOpen ? {} : { openedItem: openedItems.length > 0 ? openedItems[0] : -1 }), // For backward compatibility
        groupId: index,
        onOpen: (groupId) => setOpenedItems((prevOpenedItems) => {
            if (allowMultipleOpen) {
                return prevOpenedItems.includes(groupId)
                    ? prevOpenedItems.filter((id) => id !== groupId)
                    : [...prevOpenedItems, groupId];
            }
            return prevOpenedItems.includes(groupId) ? [] : [groupId];
        }),
        onHover: (groupId) => {
            setHoveredItem(groupId);
        },
        hoveredItem
    }))));
}
//# sourceMappingURL=AccordionWrapper.js.map